import ObjectId from 'bson-objectid';
import { Button, Col, Dropdown, Input, Text } from 'components';
import { Api, sports, theme, validateEmail } from 'lib';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Image } from 'screens/Admin/components';
import styled from 'styled-components';

const StyledDropdown = styled(Dropdown)`
  p  {
    margin: 0 19px;
  }
`;

const AddTeam = () => {
  const [name, setName] = useState(''),
    [username, setUsername] = useState(''),
    [email, setEmail] = useState(''),
    [password, setPassword] = useState(''),
    [sport, setSport] = useState(''),
    [league, setLeague] = useState(''),
    [avatar, setAvatar] = useState(null),
    [loading, setLoading] = useState(false),
    isMobile = useSelector((state) => state.appState.isMobile),
    navigate = useNavigate();

  async function submit() {
    if (!name || !username || !sport || !league || password.length < 8 || !validateEmail(email)) {
      return alert('All fields are required!');
    }

    let data = new FormData();

    data.append('name', name);
    data.append('username', username);
    data.append('email', email);
    data.append('sport', sport);
    data.append('league', league);
    data.append('password', password);
    data.append('type', 'team');

    if (avatar) {
      const avatarId = ObjectId().toString();
      data.append('avatar', avatar[1], `${avatarId}-avatar.jpeg`);
      data.append('fileName', `${avatarId}-avatar.jpeg`);
    }

    const res = await Api.post('/admin/createUser', data, 'addTeam');
    if (!res) return console.log('Something went wrong!');

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate('/admin/teams');
    }, 1000);
  }

  if (isMobile) {
    return (
      <Col center pad="20px" ht="100vh">
        <Text h1>Please visit this screen on a computer browser.</Text>
      </Col>
    );
  }

  return (
    <Col bg={theme.GREY_10} wid="100%">
      <Col bg={theme.GREY_10} ht="100%" wid="1140px" pad="50px 20px" center>
        <Col>
          <Text size="30px" marg="0 0 50px" med>
            ADD TEAM
          </Text>

          <Input
            onChange={({ target }) => setName(target.value)}
            value={name}
            marg="0 0 20px"
            placeholder="Name"
            admin
          />

          <Input
            onChange={({ target }) => setUsername(target.value)}
            value={username}
            marg="0 0 20px"
            placeholder="Username"
            admin
          />

          <Input
            onChange={({ target }) => setEmail(target.value)}
            value={email}
            marg="0 0 20px"
            placeholder="Email"
            admin
          />

          <StyledDropdown
            admin
            handleSelect={(e) => setSport(e.value)}
            options={sports}
            selected={sport}
            title="Sport"
            marg="0 0 20px"
            website
            admin
            left
          />

          <Input
            onChange={({ target }) => setLeague(target.value)}
            value={league}
            marg="0 0 20px"
            placeholder="League"
            admin
          />

          <Input
            onChange={({ target }) => setPassword(target.value)}
            value={password}
            marg="0 0 20px"
            placeholder="Password"
            admin
            password
          />

          <Col minWid="250px" marg="0 0 0 20px">
            <Text med size="22px">
              Profile picture
            </Text>

            <Image imgs={avatar} setImgs={(data) => setAvatar(data)} />
          </Col>

          <Col center>
            <Button
              text="Publish"
              website
              marg="20px 0 0"
              onClick={submit}
              action="addTeam"
              disabled={loading}
            />
          </Col>
        </Col>
      </Col>
    </Col>
  );
};

export default AddTeam;
